import React from 'react'

interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  label?: string
  hasError?: boolean
}

export const Input = React.forwardRef<HTMLInputElement, InputProps>(
  ({ label, id, className = '', hasError, ...props }, ref) => {
    return (
      <div className="flex flex-col gap-1.5 w-full">
        {label && (
          <label htmlFor={id} className="text-xs font-semibold text-brand-copyright tracking-wider">
            {label}
          </label>
        )}
        <input
          id={id}
          ref={ref}
          aria-invalid={hasError || undefined}
          className={`w-full h-10 px-3 bg-white border rounded-lg text-sm text-brand-muted focus:outline-none transition-all ${
            hasError ? 'border-brand-border-error' : 'border-brand-border-light'
          } ${className}`}
          {...props}
        />
      </div>
    )
  },
)

Input.displayName = 'Input'
